/* global Excel */
import { CONFIG } from "../config";
import { OrderLine } from "../lib/models/OrderLine";

export const useWriteToOrderLines = () => {
  const write = async (data: OrderLine[]) => {
    await Excel.run(async (context) => {
      try {
        const worksheet = context.workbook.worksheets.getItem(CONFIG.ORDER_SHEET_NAME);
        const usedRowsRange = `A2:W${data.length + 1}`;
        const range = worksheet.getRange(usedRowsRange);
        await context.sync();
        range.values = data
          .sort((a, b) => {
            if (a.deliveryId === b.deliveryId) {
              if (a.lineNo < b.lineNo) return -1;
              if (a.lineNo > b.lineNo) return 1;
              return 0;
            }
            if (a.deliveryId < b.deliveryId) return -1;
            if (a.deliveryId > b.deliveryId) return 1;
            return 0;
          })
          .map((d) => d.toExcelRow());
        await context.sync();
      } catch (error) {
        console.log(error);
      }
    });
  };

  return { write };
};
